import { Menu, MenuItem, IconButton, Button, Typography, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useRef, useState } from "react";
import { generateGtmEvent } from "../../../../Helpers";

const useStyles = makeStyles((theme) => ({
  labeledButton: {
    color: theme.palette.text.secondary,
    alignItems: "center",
  },
  menuPaper: {
    boxShadow: "0px 8px 12px #00000019",
    border: "1px solid #E8E8E8",
    borderRadius: 8,
  },
  menuList: {
    minWidth: "193px",
    padding: "12px",
    "& li": {
      color: "#747474",
      fontWeight: "500",
      padding: "8px 12px",
    },
  },
}));

interface ButtonActions {
  label: string;
  color: string;
  onClick: () => void;
  visible: boolean;
  isDisabled?: boolean;
  icon?: JSX.Element;
}

type EditItemButtonProps = {
  label?: string;
  // Added because data layer requires this to be passed
  sectionName: string;
  actions: ButtonActions[];
  gtmComponent?: string;
};

export function SettingsButton(props: EditItemButtonProps) {
  const classes = useStyles();
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const cogIcon = <i className="fa-solid fa-ellipsis-vertical fa-sm"></i>;
  const { label, actions, sectionName, gtmComponent } = props;
  const HandleDataLater = (
    section: string,
    event?: string,
    text?: string,
    action?: string
  ) => {
    generateGtmEvent({
      event: event ? event : "modal",
      action: action ? action : "open",
      name: "onclick",
      type: "click",
      region: "main content",
      section: section,
      text: text ? text : "edit icon",
      component: gtmComponent,
    });
  };
  return (
    <>
      {label ? (
        <Button
          startIcon={cogIcon}
          className={classes.labeledButton}
          ref={buttonRef}
          onClick={() => {
            HandleDataLater(sectionName, "collapse");
            setMenuOpen(true);
          }}>
          <Typography sx={{ fontWeight: 500 }}>{label}</Typography>
        </Button>
      ) : (
        <Tooltip title={"View actions"} arrow={true} placement={"bottom"}>
          <IconButton
            ref={buttonRef}
            onClick={() => {
              HandleDataLater(sectionName, "collapse");
              setMenuOpen(true);
            }}>
            {cogIcon}
          </IconButton>
        </Tooltip>
      )}

      <Menu
        anchorEl={buttonRef.current}
        open={menuOpen}
        onClose={() => {
          HandleDataLater(sectionName, "collapse", "edit icon", "close");
          setMenuOpen(false);
        }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: -8 }}
        MenuListProps={{ className: classes.menuList }}
        PaperProps={{ className: classes.menuPaper }}>
        {actions.map((action, index) => {
          if (!action.visible) {
            return null;
          }
          return (
            <MenuItem
              key={index}
              disabled={action.isDisabled}
              style={{ color: action.color }}
              onClick={() => {
                HandleDataLater("edit icon", "modal", action.label);
                setMenuOpen(false);
                action.onClick();
              }}>
              {action.label}
              {action.icon}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
